export enum PresentationType {
  TvdNA = 'TvdNA',
  TvdEU = 'TvdEU',
  TvdAP = 'TvdAP',
  AllAP = 'AllAP',
  TvdLA = 'TvdLA',
  TvdIMEA = 'TvdIMEA',
  QSR = 'QSR',
  FRS = 'FRS',
  Distributor = 'Distributor',
  PestTVD = 'PestTVD',
  SMARTPOWER = 'SMARTPOWER',

  // Legacy Institutional Templates (non-NA regions)
  Education = 'Education',
  Facilities = 'Facilities',
  FoodService = 'FoodService',
  Lodging = 'Lodging',
  LongTermCare = 'LongTermCare',
  Other = 'Other',
}
